import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import User from 'helper/currentUser';
import { initialize as lDClientInit } from 'ldclient-js';
// import ActivityIndicator from '@lyearn-team/frontend-components/dist/Loader';
import DarkThemedLoader from 'components/DarkThemedLoader';
import loginPagesHashes from 'helper/loginPagesHashesES6';
import globalURL from 'helper/url';
import IntercomInit from 'components/IntercomInit';

import MaintenanceModeCheck from 'components/MaintenanceModeCheck';

import LoginWrapper from '../Components/LoginWrapper';
import LoginDarkWrapper from '../Components/DarkLoginWrapper';
import DarkCompanyLogin from '../DarkCompanyLogin';
import CompanySignup from '../CompanySignup';
import DarkResetPassword from '../DarkResetPassword';
import DarkOrganization from '../DarkOrganization';
import DarkSetPassword from '../DarkSetPassword';
import DarkSetNewPassword from '../DarkSetNewPassword';
import DarkConfirmPassword from '../DarkConfirmPassword';
import LoginRedirect from '../LoginRedirect';
import PendingUser from '../PendingUser';
import PrivacyPolicy from '../PrivacyPolicy';
import RequestDemo from '../RequestDemo';
import MaintenancePage from '../MaintenancePage';
import DarkBrowserInvalid from '../DarkBrowserInvalid';
import Logout from '../Logout';
import { saveUrlForRedirect } from '../../helper/urlHandler';
import { findCompanyName } from '../shared/static';

const privacyPageHash = '/privacy-policy';
const maintenanceModePage = '#/maintenance';

const urlIsOfLoginPages = hash => {
  let includes = false;
  const urlPath = hash.slice(1).split('?')[0];
  loginPagesHashes.forEach(path => {
    if (urlPath === path) {
      includes = true;
    }
    if (path === '/privacy-policy' && urlPath.includes(path)) {
      includes = true;
    }
  });
  return includes;
};

const user = new User();

export default class UserLogin extends React.Component {
  userLoggedOut = false;
  companyInfo = null;
  ldClient = null;
  fetchingInfo = false;

  constructor(props) {
    super(props);
    this.state = { loading: true };
    this.fetchCompanyInfo();
    if (user.id() && user.aToken()) {
      if (window.location.hash === '#/' || window.location.hash === '#/learner') {
        const analyticsObject = {
          UserLoginConstructor: Date.now()
        };
        window.localStorage.setItem('HOMEPAGE_ANALYTICS', JSON.stringify(analyticsObject));
      }
    }
  }

  // eslint-disable-next-line react/sort-comp, camelcase
  UNSAFE_componentWillReceiveProps() {
    if (
      urlIsOfLoginPages(window.location.hash) &&
      !this.fetchingInfo &&
      !this.ldClient &&
      !this.companyInfo
    ) {
      this.state.loading = true;
      this.fetchCompanyInfo();
    }
  }

  setLoadingFalseAndRegisterSW = () => {
    this.setState({ loading: false });
    window.registerServiceWorker && window.registerServiceWorker();
  };

  onLDCReady = () => {
    this.setLoadingFalseAndRegisterSW();
  };

  fetchCompanyInfo = async () => {
    this.fetchingInfo = true;
    this.companyName = findCompanyName();
    const url = `${globalURL.url}/graphql`;
    try {
      const response = await fetch(url, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          lyearn_token: 'jmggB5SE99ovAFBIm1PY'
        },
        method: 'POST',
        body: JSON.stringify({
          operationName: null,
          query: `{
            companyInfo(domain: "${this.companyName}") {
              name,
              backgroundImage,
              logo,
              companyDescription,
              userPoolId,
              loginDomainUrl,
              loginTypes,
              signupTypes,
              pid,
              id,
              twoWaySAMLLogin,
              showCompanyDetails,
              subDomain,
              companyLoginInfo {
                SAMLData {
                  samlProviderName,
                  samlSSOUrl,
                  SPInitiated,
                  IDPInitiated,
                  metadata
                }
              }
            }
          }
        `,
          variables: {}
        })
      });
      const responseJSON = await response.json();
      this.fetchingInfo = false;
      if (responseJSON.data && responseJSON.data.companyInfo) {
        this.companyInfo = responseJSON.data.companyInfo;
        this.companyInfoAvailable(responseJSON.data.companyInfo);
      } else if (window.landingDomains.includes(this.companyName)) {
        this.setLoadingFalseAndRegisterSW();
        if (!window.location.href.includes(privacyPageHash)) {
          window.location.href = '/#/organization';
        }
      } else {
        this.setLoadingFalseAndRegisterSW();
        if (!window.location.href.includes(privacyPageHash)) {
          window.location.href = '?cn=' + this.companyName + '#/organization';
        }
      }
    } catch (err) {
      this.setLoadingFalseAndRegisterSW();
      if (
        !window.location.href.includes(privacyPageHash) &&
        !window.location.href.includes(maintenanceModePage)
      ) {
        window.location.href = '?cn=' + this.companyName + '#/organization';
      }
    }
  };

  companyInfoAvailable = company => {
    if (!company || !company.pid) {
      return;
    }
    this.companyInfo = company;
    const attributes = {
      key: 'NON_LOGGED_IN_USER',
      custom: {
        companyId: this.companyInfo.pid
      }
    };

    const ldc = lDClientInit('59a41496c4918f1c793aa3c3', attributes);
    ldc.on('ready', this.onLDCReady);
    this.ldClient = ldc;
  };

  render() {
    if (this.state.loading === true) {
      return <DarkThemedLoader />;
    }
    const tempFMOLogin = !!window.localStorage.getItem('user_fmo_temp_login');

    if (!user.id() || !user.aToken() || tempFMOLogin) {
      this.userLoggedOut = true;
      if (!urlIsOfLoginPages(window.location.hash)) {
        if (tempFMOLogin) {
          window.location.href = '/#/login';
        } else {
          saveUrlForRedirect(window.location.hash);
        }
      }
    } else {
      this.userLoggedOut = false;
    }
    return (
      <div>
        <MaintenanceModeCheck companyId={this.companyInfo && this.companyInfo.pid}>
          <IntercomInit loggedOutUser={true} ldClient={this.ldClient} />
          <Switch>
            {this.userLoggedOut && !urlIsOfLoginPages(window.location.hash) && (
              <Redirect exact={false} path="/" to="/login" />
            )}
            <Route
              exact={true}
              path="/login"
              render={props => (
                <LoginDarkWrapper>
                  <DarkCompanyLogin
                    {...props}
                    companyInfo={this.companyInfo}
                    ldClient={this.ldClient}
                  />
                </LoginDarkWrapper>
              )}
            />
            <Route
              exact={true}
              path="/login-redirect"
              render={props => (
                <LoginDarkWrapper className="no-background">
                  <LoginRedirect {...props} companyInfo={this.companyInfo} />
                </LoginDarkWrapper>
              )}
            />

            <Route
              exact={true}
              path="/company-page"
              render={props => (
                <LoginDarkWrapper>
                  <PendingUser {...props} companyInfo={this.companyInfo} />
                </LoginDarkWrapper>
              )}
            />
            <Route
              exact={true}
              path="/logout"
              render={props => (
                <LoginWrapper>
                  <Logout {...props} />
                </LoginWrapper>
              )}
            />
            <Route
              exact={true}
              path="/logout/clear"
              render={props => (
                <LoginWrapper>
                  <Logout clearIndexDB={true} {...props} />
                </LoginWrapper>
              )}
            />
            <Route
              exact={true}
              path="/organization"
              render={props => (
                <LoginDarkWrapper>
                  <DarkOrganization {...props} />
                </LoginDarkWrapper>
              )}
            />
            <Route
              exact={true}
              path="/confirm-password"
              render={props => (
                <LoginDarkWrapper>
                  <DarkConfirmPassword {...props} />
                </LoginDarkWrapper>
              )}
            />
            <Route
              exact={true}
              path="/set-password"
              render={props => (
                <LoginDarkWrapper>
                  <DarkSetPassword {...props} />
                </LoginDarkWrapper>
              )}
            />
            <Route
              exact={true}
              path="/set-new-password"
              render={props => (
                <LoginDarkWrapper>
                  <DarkSetNewPassword {...props} />
                </LoginDarkWrapper>
              )}
            />
            <Route
              exact={true}
              path="/company-signup"
              render={props => (
                <LoginWrapper>
                  <CompanySignup {...props} />
                </LoginWrapper>
              )}
            />
            <Route
              exact={true}
              path="/reset-password"
              render={props => (
                <LoginDarkWrapper>
                  <DarkResetPassword {...props} />
                </LoginDarkWrapper>
              )}
            />
            <Route
              exact={false}
              path="/privacy-policy"
              render={props => <PrivacyPolicy {...props} />}
            />
            <Route
              exact={true}
              path="/request-demo"
              render={props => (
                <LoginWrapper>
                  <RequestDemo {...props} />
                </LoginWrapper>
              )}
            />
            <Route
              exact={true}
              path="/maintenance"
              render={props => (
                <LoginDarkWrapper>
                  <MaintenancePage {...props} />
                </LoginDarkWrapper>
              )}
            />
            <Route
              exact={true}
              path="/browser-invalid"
              render={props => (
                <LoginDarkWrapper>
                  <DarkBrowserInvalid {...props} />
                </LoginDarkWrapper>
              )}
            />
            {!this.userLoggedOut && <Route render={() => this.props.render(this.ldClient)} />}
            <Redirect to="/" />
          </Switch>
        </MaintenanceModeCheck>
      </div>
    );
  }
}
